// Recovered compiled webpack factory 77759. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      GracefulDegradeBoundary: function () {
        return o;
      },
      default: function () {
        return i;
      },
    }));
  let n = r(95155),
    a = r(12115);
  class o extends a.Component {
    static getDerivedStateFromError(e) {
      return { hasError: !0 };
    }
    componentDidMount() {
      let e = this.htmlRef.current;
      this.state.hasError &&
        e &&
        Object.entries(this.htmlAttributes).forEach((t) => {
          let [r, n] = t;
          e.setAttribute(r, n);
        });
    }
    render() {
      let { hasError: e } = this.state;
      return (this.rootHtml ||
        ((this.rootHtml = document.documentElement.innerHTML),
        (this.htmlAttributes = (function (e) {
          let t = {};
          for (let r = 0; r < e.attributes.length; r++) {
            let n = e.attributes[r];
            t[n.name] = n.value;
          }
          return t;
        })(document.documentElement))),
      e)
        ? (0, n.jsx)("html", {
            ref: this.htmlRef,
            suppressHydrationWarning: !0,
            dangerouslySetInnerHTML: { __html: this.rootHtml },
          })
        : this.props.children;
    }
    constructor(e) {
      (super(e),
        (this.state = { hasError: !1 }),
        (this.rootHtml = ""),
        (this.htmlAttributes = {}),
        (this.htmlRef = (0, a.createRef)()));
    }
  }
  let i = o;
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
